import React from 'react';
import NewLineage from './new-lineage';

// Wrapper to change the title and pass edit mode
const EditLineage = (props) => {
  // Extract id from route params or location state
  let id = null;
  if (props.match && props.match.params && props.match.params.id) {
    // Keep as string - don't parse to int as diagram IDs might not be integers
    id = props.match.params.id;
  } else if (props.location && props.location.state && props.location.state.id) {
    id = props.location.state.id;
  }
  // Pass id and editMode to NewLineage
  return <NewLineage {...props} id={id} editMode={true} customTitle="View & Edit Lineage" />;
};

export default EditLineage;
